import React from 'react';
import { getYTickLabelFormatted } from '../../helper/constants';
import './YAxis.styl';

const YAxis = (props) => {
  const tickElements = props.data.values.filter(d => getYTickLabelFormatted(props.currentLanguage)[d.key]).map((item, i) => {
    const y = i === 0 ?
      props.scaleY(item.key) - (props.scaleY.bandwidth() / 2)
      : props.scaleY(item.key) + (props.scaleY.bandwidth() / 2);
    return (
      <g className="tick" key={`YAxis-label-${item.key}`}>
        <line className="yAxis__tick" x1="-25" y1={y} x2="-17" y2={y} />
        <text className="YAxis__label" y={y + 4}>
          {getYTickLabelFormatted(props.currentLanguage)[item.key]}
        </text>
        <line className="yAxis__tick" x1="17" y1={y} x2="25" y2={y} />
      </g>
    );
  });

  return (
    <g className="YAxis" transform={`translate(${props.tranlateX}, 7.5)`}>{tickElements}</g>
  );
};

export default YAxis;



// WEBPACK FOOTER //
// ./src/components/YAxis/index.js